import { render, staticRenderFns } from "./ApproveModal.vue?vue&type=template&id=e7bc4804&scoped=true"
import script from "./ApproveModal.vue?vue&type=script&lang=ts"
export * from "./ApproveModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7bc4804",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Volumes/Untitled/project/185/185admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e7bc4804')) {
      api.createRecord('e7bc4804', component.options)
    } else {
      api.reload('e7bc4804', component.options)
    }
    module.hot.accept("./ApproveModal.vue?vue&type=template&id=e7bc4804&scoped=true", function () {
      api.rerender('e7bc4804', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/member/components/ApproveModal.vue"
export default component.exports